// Lauren can refresh the hero headline and ribbon each season by editing this one file.
export const SEASONAL = {
  name: "Fall",
  headline: [
    { words: ["Spotless", "spaces."], accent: false },
    { words: ["Tusk-level", "clean."], accent: true },
  ],
  ribbon: ["Leaf-Season Reset", "Holiday-Ready Kitchens", "Cozy Home Deep Cleans", "Guest-Ready Bathrooms", "Fall Move-Ins"],
};
